import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { formatDate } from '../../js/utility';
import Button from '../utility/Button';
import RatingDisplay from './RatingDisplay';
import LoadingSpinner from '../utility/LoadingSpinner';
import { connect } from 'react-redux';

import { clearApiError } from '../../actions/api';

import {
  REVIEWS_TO_SHOW_PER_CLICK as reviewsPerClick,
  REVIEWS_TO_GET_PER_FETCH as reviewsPerFetch
} from '../../constants';

import {
  fetchReviewList,
  fetchMoreReviews,
  setReviewsToShow
} from '../../actions/reviews';

import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';

// const reviews = {
//     totalReviews: 20,
//     avgRating: 5,
//     reviewList: [
//         {
//             name: 'Letisha Truly',
//             date: '2019-05-05',
//             rating: 5,
//             review: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer in malesuada lectus, ut semper erat. Suspendisse tristique fermentum turpis ac dictum. Phasellus tincidunt vel ante a interdum. Ut vel dictum orci, non pellentesque elit. Nunc non ullamcorper libero.'
//         },
//         {
//             name: 'Letisha Truly',
//             date: '2019-07-05',
//             rating: 4,
//             review: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer in malesuada lectus, ut semper erat. Suspendisse tristique fermentum turpis ac dictum. Phasellus tincidunt vel ante a interdum. Ut vel dictum orci, non pellentesque elit. Nunc non ullamcorper libero.'
//         },
//     ],
// };

class ReviewList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initData: false
    };
    this.initData = this.initData.bind(this);
    this.showMoreReviews = this.showMoreReviews.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    const { clearApiError } = this.props;
    clearApiError();
    this.initData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async initData() {
    const { fetchReviewList, slug } = this.props;
    await fetchReviewList(slug);
    if (this._isMounted) {
      this.setState({
        initData: true
      });
    }
  }

  async showMoreReviews() {
    const {
      fetchMoreReviews,
      reviewsToShow,
      setReviewsToShow,
      reviewList,
      totalReviews,
      offset,
      slug
    } = this.props;

    if (reviewsToShow < totalReviews) {
      let newReviewsToShow = reviewsToShow;
      let toAdd =
        reviewsToShow + reviewsPerClick > totalReviews
          ? totalReviews - reviewsToShow
          : reviewsPerClick;
      newReviewsToShow = reviewsToShow + toAdd;
      if (reviewList.length < newReviewsToShow) {
        await fetchMoreReviews(slug, offset, reviewsPerFetch);
      }
      setReviewsToShow(newReviewsToShow);
    }
  }

  render() {
    const { initData } = this.state;
    const { loading } = this.props;
    if (!initData) {
      return <LoadingSpinner />;
    }
    const {
      error,
      reviewList,
      avgRating,
      totalReviews,
      reviewsToShow,
      t
    } = this.props;
    return (
      <div className='fe-review-list-container'>
        {error || totalReviews === 0 ? (
          <div className='fe-review-list-error'>
            {error ? t('trip:loadReviewsFail') : t('trip:noReviews')}
          </div>
        ) : (
          <>
            <header className='fe-review-list-header'>
              <div className='fe-review-list-header-text'>
                <h3 className='fe-review-list-total'>
                  {t('trip:numReviews', {
                    num: totalReviews,
                    count: totalReviews
                  })}
                </h3>
                <p>{t('trip:whatOthersSay')}</p>
              </div>
              <div className='fe-review-list-header-avg'>
                <span>{t('trip:avgRating')}</span>
                <RatingDisplay rating={avgRating} big />
              </div>
            </header>
            <div className='fe-review-list'>
              {reviewList.slice(0, reviewsToShow).map(review => (
                <div key={review.id} className='fe-review-list-item'>
                  <header className='fe-review-list-item-header'>
                    <div className='fe-review-list-item-header-details'>
                      <div className='fe-review-list-item-name'>
                        {review.name}
                      </div>
                      <div className='fe-review-list-item-date'>
                        {formatDate(review.date)}
                      </div>
                    </div>
                    <RatingDisplay rating={review.rating} />
                  </header>
                  <div className='fe-review-list-item-content'>
                    <p>{review.review}</p>
                    {/* <h5 className='fe-review-list-item-heading'> */}
                      {/* {t('trip:drivingExperience')}: */}
                    {/* </h5> */}
                    {/* <div className='fe-my-booking-item-vehicle'>
                      {!review.is_own_vehicle ? (
                        <div className='fe-my-booking-item-vehicle-thumb'>
                          <div className='fe-u-thumb-3by1'>
                            <img src={review.vehicle.img_url} alt='' />
                          </div>
                        </div>
                      ) : (
                        <img
                          className='fe-my-booking-item-byoc'
                          src={iconBYOC}
                          alt=''
                        />
                      )}
                      <span>
                        {!review.is_own_vehicle
                          ? review.vehicle.model
                          : t('gen:bringOwnRanger')}
                      </span>
                    </div> */}
                    <p>{review.vehicle_review}</p>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {loading && !error ? <LoadingSpinner height={200} /> : null}
        {reviewsToShow < totalReviews && !loading ? (
          <Button alt onClick={this.showMoreReviews}>
            {t('trip:showMoreReviews')}
          </Button>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({ reviewsState }) => ({
  loading: reviewsState.loading,
  error: reviewsState.error,
  reviewList: reviewsState.reviewList,
  totalReviews: reviewsState.totalReviews,
  avgRating: reviewsState.avgRating,
  loadingMore: reviewsState.loadingMore,
  offset: reviewsState.offset,
  reviewsToShow: reviewsState.reviewsToShow
});

const mapDispatchToProps = {
  fetchReviewList,
  clearApiError,
  fetchMoreReviews,
  setReviewsToShow
};

ReviewList.propTypes = {
  slug: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  loadingMore: PropTypes.bool.isRequired,
  reviewList: PropTypes.array.isRequired,
  totalReviews: PropTypes.number.isRequired,
  avgRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  offset: PropTypes.number.isRequired,
  reviewsToShow: PropTypes.number.isRequired,
  error: PropTypes.object,
  fetchReviewList: PropTypes.func.isRequired,
  clearApiError: PropTypes.func.isRequired,
  fetchMoreReviews: PropTypes.func.isRequired,
  setReviewsToShow: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReviewList)
);
